'use client';

import { useAppSelector } from '@/store/hook';
import { selectIsGlobalLoading } from '@/features/ui/uiLoadingSlice';
import LoadingSpinner from '../ui/loading/LoadingSpinner';

export default function GlobalLoadingOverlay() {
  const isLoading = useAppSelector(selectIsGlobalLoading);

  if (!isLoading) return null;

  return <LoadingSpinner />;
}
